import { Button, Modal, Stack, Text } from "@mantine/core";
import { IconClock } from "@tabler/icons-react";

export default function DatasourceAccessPendingModal({
    opened,
    onClose,
    datasourceName,
}: {
    opened: boolean;
    onClose: () => void;
    datasourceName: string;
}) {
    return (
        <Modal
            size="md"
            opened={opened}
            onClose={onClose}
            title={`Access to ${datasourceName}`}
            closeButtonProps={{ "aria-label": "Close modal" }}
        >
            <Stack align="center" gap="md" py="md">
                <IconClock size={48} color="#f59e0b" />
                <Text ta="center" size="sm">
                    You've already submitted a request for access to{" "}
                    <Text span fw={600}>
                        {datasourceName}
                    </Text>
                    . An admin will review it shortly.
                </Text>
                <Button onClick={onClose}>Got it</Button>
            </Stack>
        </Modal>
    );
}
